import { Component, Input, EventEmitter, Output, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { InfluencerCampaignStatus } from '../../../../models/influencer-campaign';

@Component({
  selector: 'campaign-status-slider',
  templateUrl: './campaign-status-slider.component.html',
  styleUrls: ['./campaign-status-slider.component.scss']
})
export class CampaignStatusSliderComponent implements OnChanges {
  @Input() slider: InfluencerCampaignStatus[];
  @Input() readonly = false;
  @Output() changeStatus = new EventEmitter<any>();
  public currentStatus = new InfluencerCampaignStatus();
  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    this.updateCurrentStatus();
  }

  private updateCurrentStatus() {
    this.slider.forEach(item => {
      if (item.selected) {
        this.currentStatus = item;
      }
    });
  }

  public change(event) {
    if (this.readonly) {
      return;
    }
    this.changeStatus.emit(event);
    this.slider.forEach(item => {
      if (item.selected) {
        item.selected = false;
      }
    });
    event.selected = true;
    this.currentStatus = event;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/campaign-new/campaign-status-slider/campaign-status-slider.component.ts